import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import { Franchise } from '../../interface/tenant/franchise.interface';
import { Distribution } from '../../interface/distributions/distributions';
import { AuthService } from '../auth/auth.service';
import { localStorageVar } from 'src/app/modules/admin/pages/localstoragevar';

@Injectable({
  providedIn: 'root'
})
export class FranchisesService {

  constructor(private _httpService: HttpService, private auth:AuthService) { }

  public async getAll(): Promise<Franchise[]> {
    return firstValueFrom(this._httpService.get('/franchises'));
  }

    public async create(data: Distribution): Promise<Distribution> {
      return (await firstValueFrom(this._httpService.post('/franchises', data)).then(x => {
        let franchises = this.auth.franchises.values;
        localStorage.setItem(localStorageVar.franchises, JSON.stringify(franchises));
        this.auth.RefreshFranchises();
        return x;
      }));
    }

      public async update(id: number, data: Distribution): Promise<Distribution> {
        const result: any = await firstValueFrom(this._httpService.patch('/franchises/', id, data));
        // The backend returns the full entity graph (including users with password hashes) —
        // only merge the display fields the app actually needs, never persist the raw response.
        const { name, address, phone, settingsId, settings } = result;
        if (this.auth.activeFranchise.id === id) {
          const updatedActive = { ...this.auth.activeFranchise, name, address, phone, settingsId, settings };
          localStorage.setItem(localStorageVar.activeFranchise, JSON.stringify(updatedActive));
        }
        const franchises = this.auth.franchises;
          const updatedFranchises = franchises.map(f => f.id === id ? { ...f, name } : f);
          localStorage.setItem(localStorageVar.franchises, JSON.stringify(updatedFranchises));
        this.auth.RefreshFranchises();
        return result;
      }
    

  async updateCashInHandBank(bankId: number | null): Promise<void> {
    await firstValueFrom(this._httpService.patch('/franchises/settings/bank', '', bankId));
  }
}
